import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const SectionCTALayout3 = () => {
  return (
    <section className="pb-16 dark:bg-slate-900">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{
            delay: 0.5,
          }}
        >
         <div className="mx-auto max-w-5xl px-6 mt-10">
  <div className="relative overflow-hidden rounded-xl text-center p-10 shadow-sm dark:shadow-slate-950/40">
    <div className="relative mx-auto w-full md:w-2/3">
      <h2 className="mb-4 text-2xl text-[#011473] md:text-3xl font-semibold">
        Partner With Visa World
      </h2>
      <p className="mb-8 text-lg md:text-md max-w-xl mx-auto">
        Experience seamless visa and immigration services with Visa World. Let us help you navigate your journey to your desired destination!
      </p>
      <Link to="/contact">
        <Button size="lg" className="px-8 py-3 text-sm md:px-4 md:py-0">Join Hands With Us</Button>
      </Link>
    </div>
  </div>
</div>

        </motion.div> 
      </div>
    </section>
  );
};

export default SectionCTALayout3;
